import { useSearchParams } from 'react-router-dom';

import { CreateOrganizationPage } from '~/components/pages/CreateOrganizationPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';

export const CreateOrganizationRoute: React.FC = () => {
  const [searchParams] = useSearchParams();

  return (
    <DashboardTemplate>
      <CreateOrganizationPage
        nextUrl={searchParams.get('nextUrl') ?? undefined}
        cancelUrl={searchParams.get('cancelUrl') ?? undefined}
      />
    </DashboardTemplate>
  );
};
